import VeLocale from 'vue-easytable/packages/ve-locale';

/**
 * Traduz o paginador do `vue-easytable`.
 *
 * O pacote tem catálogo próprio (`packages/src/locale/lang/`) e não traz português: sem
 * isto, "Total 21", "25 / page" e "Go to" aparecem em inglês no meio de uma tela toda
 * traduzida — em TODA tabela do produto que use `VePagination`, não só nos relatórios de
 * pesquisa.
 *
 * `VeLocale.use` faz merge no catálogo global e o valor é reativo (o pacote registra com
 * `Vue.util.defineReactive`), então chamar de novo ao trocar de idioma re-renderiza o que
 * já está na tela — não é preciso recarregar.
 *
 * `total` é função por exigência do pacote, não escolha nossa.
 */
export const syncEasytableLocale = i18n => {
  const t = key => i18n.t(`GENERAL.DATA_TABLE.PAGINATION.${key}`);

  VeLocale.use({
    pagination: {
      goto: t('GOTO'),
      // O pacote imprime `page` colado no campo de ir para. Em português a frase fecha
      // sem sufixo, e o inglês também deixa vazio.
      page: '',
      itemsPerPage: t('ITEMS_PER_PAGE'),
      total: count => i18n.t('GENERAL.DATA_TABLE.PAGINATION.TOTAL', { count }),
      prev5: t('PREV_5'),
      next5: t('NEXT_5'),
    },
  });
};

export default syncEasytableLocale;
